import Vue from 'vue'
import Vuex from 'vuex';
Vue.use(Vuex);

// ヘッダーコンポーネント
Vue.component('c-header', 	require( 'js/parts_com/Header.vue' ));
	Vue.component('c-listitem', require('js/parts_com/listItem.vue'));
	Vue.component('c-viewdialog', 	require( 'js/parts_com/frameDialog.vue'));
	Vue.component('c-wndselectone', 	require( 'js/parts_com/wndSelectOne.vue'));
		Vue.component('c-selectionifsearch', 	require( 'js/parts_com/search/ifSearchSelection.vue'));
		Vue.component('c-listheaders', require('js/parts_com/listHeader.vue'));
		Vue.component('c-searchname', 		require('js/parts_com/search/editSearchText.vue'));
			Vue.component('c-inputedit', 	require('js/parts_com/inputEdit.vue'));
		Vue.component('c-searchcode', 		require('js/parts_com/search/editCodeFromTo.vue'));
			Vue.component('c-inputedit', 	require('js/parts_com/inputEdit.vue'));
		// メッセージ表示
		Vue.component('c-msgdisp', require('js/parts_com/viewMessageDisp.vue'));
		// ページネーション
		Vue.component('c-pagination', 	require('js/parts_com/viewPaging.vue'));
			Vue.component('c-selectitem', 	require('js/parts_com/selectItem.vue'));
			
			
	// 3, ユーザー画面
	Vue.component('c-viewdetail-user', 	require('js/parts_com/wndDetail2.vue'));
		// 機能実装
		Vue.component('c-funcdetail-user', 	require('js/parts/user/header/funcDetail.vue'));
		// 詳細画面表示ボタン
		Vue.component('c-btns-wnd-detail', 	require('js/parts_com/btnsWndDetail.vue'));
		// メッセージ表示
		Vue.component('c-message-accordion', require('js/parts_com/viewMessageDetail.vue'));
			Vue.component('c-message-list', require('js/parts_com/MessageList.vue'));
		// パラメータ表示
		Vue.component('c-user-viewparam', require('js/parts/user/header/viewParam.vue'));
			Vue.component('c-viewHeaderParam', require('js/parts/user/header/viewHeaderParam.vue'));
				Vue.component('c-edit-select-btn-info', 	require('js/parts_com/TR/editSelectBtnInfo.vue'));
				Vue.component('c-edititemcode', 	require('js/parts_com/TR/editCode.vue'));
				Vue.component('c-edittext', 	require('js/parts_com/TR/editText.vue'));
				Vue.component('c-editsystemcode', 	require('js/parts_com/TR/editSystemCode.vue'));
				Vue.component('c-editdatepicker', 	require('js/parts_com/TR/editDatePicker.vue'));
					Vue.component('c-input-date-picker', 	require('js/parts_com/inputCalendar.vue'));
						Vue.component('c-ifsearchpaging', 		require('js/parts_com/viewPaging.vue'));
							Vue.component('c-selectitem', 	require('js/parts_com/selectItem.vue'));
				Vue.component('c-editcharger', 	require('js/parts_com/TR/editCharger.vue'));
				Vue.component('c-editselectpulldown', 	require('js/parts_com/TR/editSelectPullDown.vue'));
					Vue.component('c-selectitem', 	require('js/parts_com/selectItem.vue'));
		Vue.component('c-user-password', 	require('js/parts_com/viewPassword.vue'));


// WEBPACK FOOTER //
// ./resources/assets/js/public/common_component.js